module.exports = __webpack_public_path__ + "img/credential9.021255ff.png";